import type { InputHTMLAttributes } from 'react'

interface InputProps extends InputHTMLAttributes<HTMLInputElement> {
  label?: string
  error?: string
}

export default function Input({ label, error, className = '', id, ...props }: InputProps) {
  const inputId = id || props.name

  return (
    <div className="w-full">
      {label && (
        <label htmlFor={inputId} className="block text-sm font-medium text-brand-muted mb-2">
          {label}
          {props.required && <span className="text-accent-teal ml-1">*</span>}
        </label>
      )}
      <input
        id={inputId}
        className={`
          w-full px-[18px] py-[14px]
          bg-white/[0.03] border border-white/[0.1] rounded-lg
          text-brand-light placeholder-[#6b6965]
          focus:outline-none focus:border-accent-teal focus:ring-[3px] focus:ring-accent-teal/10
          transition-all duration-300 ease-out
          ${error ? 'border-red-500' : ''}
          ${className}
        `}
        {...props}
      />
      {error && <p className="mt-1.5 text-sm text-red-500">{error}</p>}
    </div>
  )
}
